module.exports = __webpack_public_path__ + "static/media/Visa.3807cd62.svg";